import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from './api-client.service';
import { PostPayByLinkRequest } from '../Models/Requests/PostPayByLinkRequest';
import { PostPayByLinkResponse } from '../Models/Responses/PostPayByLinkResponse';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  private readonly apiService = inject(ApiClientService);

  public getLinkForPayment (request : PostPayByLinkRequest) : Observable<PostPayByLinkResponse> {
    const params = {
      paymentAmount: request.paymentAmount.toFixed(2),
    };

    return this.apiService.post<PostPayByLinkResponse>(`api/v2/cases/pay-by-link/${request.caseIdHash}`, false, params);
  }
}
